import { Component, computed, OnInit } from '@angular/core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { StatusInterfaceCMDB } from 'src/app/util/interfaces/statusInterface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { StatusCiTypeService } from './service/status-ci-type.service';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { ModelService } from '../model/service/model.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { MspTableRmkComponent } from 'src/app/page_component_item/msp-table-rmk/msp-table-rmk.component';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { MspButtonComponent } from 'src/app/page_component_item/msp-button/msp-button.component';
import { mspTableSort } from 'src/app/page_component_item/msp-table-rmk/components/msp-table.interfaces';

@Component({
	selector: 'register-form-status-ci-type',
	standalone: true,
	imports: [MspTableRmkComponent, DotBounceLoadingEffectModule, FontAwesomeModule, FormsModule, MspButtonComponent],
	templateUrl: './status-ci-type.component.html',
	styleUrl: './status-ci-type.component.scss',
})
export class StatusCiTypeComponent implements OnInit {
	icons = {
		faInfoCircle: faInfoCircle,
	};

	labels: LabelsInterface = {
		lbl_geral_ativo: 'Active',
		lbl_geral_selecione: 'Select',
		lbl_geral_location_limpar_campos: 'Reset the fields',
		lbl_geral_novo: 'New',
		lbl_geral_location_ativar: 'Activate',
		lbl_geral_desativar: 'Inactivate',
		lbl_cmdb_nao: 'Not',
		lbl_geral_sim: 'Yes',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_ativado: 'Activated',
		lbl_status_desativado: 'Inactive',
		lbl_geral_limpar_campos: 'Clear Fields',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
		lbl_status_relacionado: 'Status Related',
		lbl_vincular_status_estoque:
			'*If the status being created is related to inventory, it needs to be linked to a standard inventory system status',
		lbl_status_ci: 'CI Status',
	};

	statusIntarface: StatusInterfaceCMDB = {
		id: undefined,
		status: '',
		ci_type: '',
		status_active: '',
		id_ci_type: '',
		active: '',
	};

	isLoadingStatus = true;

	searchHeader: mspTableHeaderI[];
	sort: mspTableSort = {
		sortBy: 'status',
		sortOrder: 'desc',
		sortDown: false,
	};
	statusList: StatusInterfaceCMDB[] = [];
	statusListTable = () => {
		return this.statusList
			.map((item) => {
				return {
					...item,
					status_active: item.status_active.toString() == '1' ? this.labels.lbl_geral_ativo : this.labels.lbl_geral_desativado,
					active: item.active.toString() == '1' ? this.labels.lbl_geral_ativo : this.labels.lbl_geral_desativado,
				};
			})
			.sort((a, b) => {
				const fieldA = a[this.sort.sortBy] ? a[this.sort.sortBy].toString().toLowerCase() : '';
				const fieldB = b[this.sort.sortBy] ? b[this.sort.sortBy].toString().toLowerCase() : '';
				if (fieldA < fieldB) return this.sort.sortOrder === 'desc' ? -1 : 1;
				if (fieldA > fieldB) return this.sort.sortOrder === 'desc' ? 1 : -1;
				return 0;
			});
	};
	onLineClick: (statusinterface: StatusInterfaceCMDB) => void = (statusinterface: StatusInterfaceCMDB) => {
		const statusObject = this.statusList.find((item) => item.id === statusinterface.id);
		this.openForm(statusObject!);
	};

	statusPatternList: StatusInterfaceCMDB[] = [];
	ciTypeList: ciTypesInterface[] = [];
	isSavingForm = false;

	constructor(
		private notification: NotificationService,
		private LabelsService: LabelsService,
		private statusCiTypeService: StatusCiTypeService,
		private modelService: ModelService
	) {
		this.labels = computed(() => this.LabelsService.labels())();
	}

	ngOnInit() {
		this.getAllStatus();
		this.getAllCiType();
		this.getStatusPattern();

		this.searchHeader = [
			{ name: 'status', value: this.labels['lbl_geral_status'], colType: 'text' },
			{ name: 'ci_type', value: this.labels['lbl_asset_tipo_ci'], colType: 'text' },
			{ name: 'status_active', value: this.labels['lbl_status_ci'], colType: 'text' },
			{ name: 'status_related', value: this.labels['lbl_status_relacionado'], colType: 'text' },
			{ name: 'active', value: this.labels['lbl_geral_ativo'], colType: 'text' },
		];
	}

	getAllStatus(): void {
		this.statusCiTypeService.getStatusCiType().subscribe((data) => {
			this.statusList = data;
			this.isLoadingStatus = false;
		});
	}

	getAllCiType(): void {
		this.modelService.getAllCiType().subscribe((ciType) => {
			this.ciTypeList = [];
			this.ciTypeList = ciType;
		});
	}

	getStatusPattern(): void {
		this.statusCiTypeService.getStatusPattern().subscribe((statusPattern) => {
			this.statusPatternList = [];
			this.statusPatternList = statusPattern;
		});
	}

	clearInputs(isNew: boolean): void {
		this.statusIntarface = {
			id: isNew ? '' : undefined,
			status: '',
			ci_type: '',
			status_active: '',
			id_ci_type: '',
			status_related: '',
			active: '',
		};

		if (isNew === false) {
			this.getAllStatus();
			this.isLoadingStatus = true;
		}
	}

	cleanValues(): void {
		this.statusIntarface = {
			id: '',
			status: '',
			ci_type: '',
			status_active: '',
			id_ci_type: '',
			status_related: '',
			active: '',
		};

		this.statusList = [];
		this.getAllStatus();
		this.isLoadingStatus = true;
	}

	validateForm(): any {
		if (this.statusIntarface.status === '' || this.statusIntarface.status_active === '' || this.statusIntarface.active === '') {
			this.notification.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return false;
		} else {
			this.save();
		}
	}

	save(): void {
		if (this.isSavingForm) return;

		this.isSavingForm = true;
		if (this.statusIntarface.id) {
			// Se 'id' estiver definido, é uma atualização, então fazemos uma solicitação PUT
			this.statusCiTypeService.putStatusCiType(this.statusIntarface).subscribe({
				next: (data) => {
					this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
					this.isLoadingStatus = true;
					this.getAllStatus();
					this.cleanValues();
					this.clearInputs(false);
					this.isSavingForm = false;
				},
				error: (error) => {
					this.notification.setNotificationMessage(error.statusText);
					this.isSavingForm = false;
				},
			});
		} else {
			// Se 'id' for vazio, é uma nova entrada, então fazemos uma solicitação POST
			this.statusCiTypeService.postStatusCiType(this.statusIntarface).subscribe({
				next: (data) => {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.isLoadingStatus = true;
					this.getAllStatus();
					this.cleanValues();
					this.clearInputs(false);
					this.isSavingForm = false;
				},
				error: (error) => {
					this.notification.setNotificationMessage(error.statusText);
					this.isSavingForm = false;
				},
			});
		}
	}

	openForm(item: StatusInterfaceCMDB): void {
		this.statusIntarface.id = item.id;
		this.statusIntarface.ci_type = item.ci_type == 'N/A' ? '' : item.id_ci_type.toString();
		this.statusIntarface.status_active = item.status_active == '1' ? '1' : '0';
		this.statusIntarface.status = item.status;
		this.statusIntarface.status_related = item.status_related == 'N/A' ? '' : item.status_related;
		this.statusIntarface.active = item.active == '1' ? '1' : '0';
	}
}
